import { Typography } from "@mui/material";
import { useMemo } from "react";
import { Dialog } from "../../components/dialogs/Dialog";
import { useLocale } from "../../providers/LocaleProvider";

const ImportCompeteniesErrorDialog = (props: any) => {
  const { theme, onClose, open = false, competencies = [], description, title } = props;
  const { translate } = useLocale();

  const isMultipleCompetencies = useMemo(() => competencies.length > 1, [competencies]);

  return (
    <Dialog
      open={open}
      theme={theme}
      onClose={onClose}
      fullWidth={true}
      maxWidth='sm'
      title={title || translate("settings.importCompetencies")}
      actions={[
        {
          label: translate("common.cancel"),
          primary: true,
          variant: "filled",
          disabled: false,
          onClick: onClose
        }
      ]}
    >
      <Typography>
        {description ||
          translate(
            isMultipleCompetencies
              ? "settings.importCompetenciesErrorMultiple"
              : "settings.importCompetenciesErrorSingle"
          )}
      </Typography>

      <ul>
        {competencies.map((competency: any, index: number) => (
          <li key={index}>
            <Typography>{competency.name}</Typography>
          </li>
        ))}
      </ul>
    </Dialog>
  );
};

export default ImportCompeteniesErrorDialog;
